export default __webpack_public_path__ + "static/media/JobSix5.cc9d0469.jpg";